import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { DownloadComponent } from './download/download.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { StepfinalComponent } from './stepper/steps/stepfinal/stepfinal.component';
import { SteponeComponent } from './stepper/steps/stepone/stepone.component';
import { SteptwoComponent } from './stepper/steps/steptwo/steptwo.component';
import { DropdownWithoutLabelComponent } from './dropdown-without-label/dropdown-without-label.component';
import { StepperwithrouteComponent } from './stepper/stepperwithroute/stepperwithroute.component';
import { StepperComponent } from './stepper/stepper.component';
import { ToggleComponent } from './toggle/toggle.component';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { GlobalNavigationComponent } from './global-navigation/global-navigation.component';
import { GlobalNavigationSpanishComponent } from './global-navigation/global-navigation-spanish/global-navigation-spanish.component';
import { GlobalNavigationHindiComponent } from './global-navigation/global-navigation-hindi/global-navigation-hindi.component';
import { MenuDisplayComponent } from './menu-display/menu-display.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ToastComponent } from './toast/toast.component';
import { HeaderMultiLanguageComponent } from './header-multi-language/header-multi-language.component';
import { FooterMultiLanguageComponent } from './footer-multi-language/footer-multi-language.component';
import { FormElementComponent } from './form-element/form-element.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
import { TabComponent } from './tab/tab.component';
import { SearchComponent } from './search/search.component';
import { NotificationInlineComponent } from './notification-inline/notification-inline.component';
import { HotCornerComponent } from './hot-corner/hot-corner.component';
import { FloatingPanelComponent } from './floating-panel/floating-panel.component';
import { ListComponent } from './list/list.component';
import { PagelistComponent } from './page-list/page-list.component';
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalnavdemoComponent } from './globalnavdemo/globalnavdemo.component';
import { DialogComponent } from './dialog/dialog.component';
import { SidePanelComponent } from './side-panel/side-panel.component';
import { CourseLevelContentCardComponent } from './course-level-content-card/course-level-content-card.component';
import { NavigationDrawerComponent } from './navigation-drawer/navigation-drawer.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MenubarComponent } from './menubar/menubar.component';
import { CascadeMenubarComponent } from './cascade-menubar/cascade-menubar.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { LinkComponent } from './link/link.component';
import { ErrorStateComponent } from './error-state/error-state.component';
import { TextAreaComponent } from './text-area/text-area.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ReadAloudComponent } from './read-aloud/read-aloud.component';
import { DraggableComponent } from './draggable/draggable.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { PlayerComponent } from './player/player.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { TimeInputComponent } from './time-input/time-input.component';
import { LoaderComponent } from './loader/loader.component';
import { AccordianComponent } from './accordian/accordian.component';
import { BadgeComponent } from './badge/badge.component';
import { ChipComponent } from './chip/chip.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DateInputComponent } from './date-input/date-input.component';
import { PaginationComponent } from './pagination/pagination.component';
import { RadioComponent } from './radio/radio.component';
import { ListCardComponent } from './list-card/list-card.component';
import { IndicatorComponent } from './indicator/indicator.component';
import { TreeComponent } from './tree/tree.component';
import { FunctionCardComponent } from './function-card/function-card.component';
import { ActionCardComponent } from './action-card/action-card.component';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { MultiLevelProgressBarComponent } from './multi-level-progress-bar/multi-level-progress-bar.component';
import { TableComponent } from './table/table.component';
import { NavigationDrawerCase1Component } from './navigation-drawer-case1/navigation-drawer-case1.component';
import { SampleModuleForNavigationDrawerComponent } from './sample-module-for-navigation-drawer/sample-module-for-navigation-drawer.component';
import { NavigationDrawerWithSubModulesModule } from './navigation-drawer-with-sub-modules/navigation-drawer-with-sub-modules.module';
import { GlobalNavigationHeaderComponent } from './global-navigation-header/global-navigation.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { GradingCardComponent } from './grading-card/grading-card.component';
import { FilterToolbarComponent } from './filter-toolbar/filter-toolbar.component';
import { SummaryBarComponent } from './summary-bar/summary-bar.component';
import { ProgressCardComponent } from './progress-card/progress-card.component';
import { IconComponent } from './icon/icon.component';
import { GlobalNavigationWithThemeComponent } from './navigation-drawer-with-Theme/global-navigation/global-navigation.component';
import { ZoomComponent } from './zoom/zoom/zoom.component';
import { CardSliderComponent } from './card-slider/card-slider.component';
import { MultiRangeSliderComponent } from './multi-range-slider/multi-range-slider.component';
import { carouselWithSlidebarComponent } from './carousel-with-slidebar/carousel-with-slidebar.component';
import { NavigationDrawerWithSubChildComponent } from './navigation-drawer-with-sub-child/navigation-drawer-with-sub-child.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'button',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'header',
    component: HeaderMultiLanguageComponent
  },
  {
    path: 'button',
    component: ButtonComponent
  },
  {
    path: 'card',
    component: CardComponent
  },
  {
    path: 'download',
    component: DownloadComponent
  },
  {
    path: 'toast',
    component: ToastComponent
  },
  {
    path: 'dropdown-without-label',
    component: DropdownWithoutLabelComponent
  },
  {
    path: 'stepper',
    component: StepperComponent
  },
  {
    path: 'stepperroute',
    component: StepperwithrouteComponent,
    children: [
      {
        path: '',
        redirectTo: 'stepone',
        pathMatch: 'full'
      },
      {
        path: 'stepone',
        component: SteponeComponent
      },
      {
        path: 'steptwo',
        component: SteptwoComponent
      },
      {
        path: 'stepfinal',
        component: StepfinalComponent
      }
    ]
  },
  {
    path: 'toggle',
    component: ToggleComponent
  },
  {
    path: 'modal-header',
    component: ModalHeaderComponent
  },
  {
    path: 'sidePanel',
    component: SidePanelComponent
  },
  {
    path: 'global-navigation',
    component: GlobalNavigationComponent
  },
  {
    path: 'global-navigation-with-theme',
    component: GlobalNavigationWithThemeComponent
  },  
  {
    path: 'global-navigation-spanish',
    component: GlobalNavigationSpanishComponent
  },
  {
    path: 'global-navigation-hindi',
    component: GlobalNavigationHindiComponent
  },
  {
    path: 'dashboard',
    component: MenuDisplayComponent
  },
  {
    path: 'courses',
    component: MenuDisplayComponent
  },
  {
    path: 'classes',
    component: MenuDisplayComponent
  },
  {
    path: 'calendar',
    component: MenuDisplayComponent
  },
  {
    path: 'products',
    component: MenuDisplayComponent
  },
  {
    path: 'users',
    component: MenuDisplayComponent
  },
  {
    path: 'book',
    component: MenuDisplayComponent
  },
  {
    path: 'tableofContents',
    component: MenuDisplayComponent
  },
  {
    path: 'challenge',
    component: MenuDisplayComponent
  },
  {
    path: 'homework',
    component: MenuDisplayComponent
  },
  {
    path: 'assessments',
    component: MenuDisplayComponent
  },
  {
    path: 'reports',
    component: MenuDisplayComponent
  },
  {
    path: 'messages',
    component: MenuDisplayComponent
  },
  {
    path: 'notification',
    component: MenuDisplayComponent
  },
  {
    path: 'profile',
    component: MenuDisplayComponent
  },
  {
    path: 'help',
    component: MenuDisplayComponent
  },
  {
    path: 'logout',
    component: MenuDisplayComponent
  },
  {
    path: 'more',
    component: MenuDisplayComponent
  },
  {
    path: 'navbar',
    component: NavbarComponent
  },
  {
    path: 'footer',
    component: FooterMultiLanguageComponent
  },
  {
    path: 'formElement',
    component: FormElementComponent
  },
  {
    path: 'modal-footer',
    component: ModalFooterComponent
  },
  {
    path: 'search',
    component: SearchComponent
  },
  {
    path: 'notification-inline',
    component: NotificationInlineComponent
  },
  {
    path: 'tab',
    component: TabComponent
  },
  {
    path: 'hot-corner',
    component: HotCornerComponent
  },
  {
    path: 'floating-panel',
    component: FloatingPanelComponent
  },
  {
    path: 'global-header',
    component: GlobalHeaderComponent
  },
  {
    path: 'list',
    component: ListComponent
  },
  {
    path: 'pagelist',
    component: PagelistComponent
  },
  {
    path: 'dialog',
    component: DialogComponent
  },
  {
    path: 'course-level-content-card',
    component: CourseLevelContentCardComponent
  },
  {
    path: 'toolbar',
    component: ToolbarComponent
  },
  {
    path: 'menubar',
    component: MenubarComponent
  },
  {
    path: 'cascade-menubar',
    component: CascadeMenubarComponent
  },
  {
    path: 'navigation-drawer',
    component: NavigationDrawerComponent
  },
  {
    path: 'navigation-drawer-with-sub-child',
    component: NavigationDrawerWithSubChildComponent    
  },
  {
    path: 'navigation-drawer-case1',
    component: NavigationDrawerCase1Component
  },
  {
    path: 'navigation-drawer-SubModules',
    loadChildren: () => import('./navigation-drawer-with-sub-modules/navigation-drawer-with-sub-modules.module').then(m => m.NavigationDrawerWithSubModulesModule)
  },
  {
    path: 'navigation-drawer-theme',
    loadChildren: () => import('./navigation-drawer-with-Theme/navigation-drawer-with-Theme.module').then(m => m.NavigationDrawerWithThemeModule)
  },
  {
    path: 'sample-module-for-navigation-drawer',
    component: SampleModuleForNavigationDrawerComponent
  },
  {
    path: 'dropdown',
    component: DropdownComponent
  },
  {
    path: 'global-nav-demo',
    component: GlobalnavdemoComponent
  },
  {
    path: 'Link',
    component: LinkComponent
  },
  {
    path: 'error-state',
    component: ErrorStateComponent
  },
  {
    path: 'text-area',
    component: TextAreaComponent
  },
  {
    path: 'breadcrumbs',
    component: BreadcrumbsComponent
  },
  {
    path: 'read-aloud',
    component: ReadAloudComponent
  },
  {
    path: 'draggable',
    component: DraggableComponent
  },
  {
    path: 'progress-bar',
    component: ProgressBarComponent
  },
  {
    path: 'checkbox',
    component: CheckboxComponent
  },
  {
    path: 'player',
    component: PlayerComponent
  },
  {
    path: 'tooltip',
    component: TooltipComponent
  },
  {
    path: 'multi-select',
    component: MultiSelectComponent
  },
  {
    path: 'time-input',
    component: TimeInputComponent
  },
  {
    path: 'loader',
    component: LoaderComponent
  },
  {
    path: 'accordian',
    component: AccordianComponent
  },
  {
    path: 'badge',
    component: BadgeComponent
  },
  {
    path: 'chip',
    component: ChipComponent
  },
  {
    path: 'spinner',
    component: SpinnerComponent
  },
  {
    path: 'date-input',
    component: DateInputComponent
  },
  {
    path: 'pagination',
    component: PaginationComponent
  },
  {
    path: 'radio',
    component: RadioComponent
  },
  {
    path: 'list-card',
    component: ListCardComponent
  },
  {
    path: 'textEditor',
    component: TextEditorComponent
  },
  {
    path: 'indicator',
    component: IndicatorComponent
  },
  {
    path: 'tree',
    component: TreeComponent
  },
  {
    path: 'function-card',
    component: FunctionCardComponent
  },
  {
    path: 'action-card',
    component: ActionCardComponent
  },
  {
    path: 'numeric-input',
    component: NumericInputComponent
  },
  {
    path: 'multi-level-progress',
    component: MultiLevelProgressBarComponent
  },
  {
    path: 'table',
    component: TableComponent
  },
  {
    path: 'GlobalNavigationHeaderComponent',
    component: GlobalNavigationHeaderComponent
  },
  {
    path: 'pageHeader',
    component: PageHeaderComponent
  },
  {
    path: 'gradingCard',
    component: GradingCardComponent
  },
  {
    path: 'filter-sorting',
    component: FilterToolbarComponent
  },
  {
    path: 'summarybar',
    component: SummaryBarComponent
  },
  {
    path: 'progress-card',
    component: ProgressCardComponent
  },
  {
    path: 'icon',
    component: IconComponent
  },
  {
    path: 'zoom',
    component: ZoomComponent
  },
  {
    path: 'card-slider',
    component: CardSliderComponent
  },
  {
    path: 'multi-range-slider',
    component: MultiRangeSliderComponent
  },
   {
    path: 'carousel-with-slidebar',
    component: carouselWithSlidebarComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }